import "../Styles/CartProcess.css";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { generatePath, useNavigate, useLocation } from "react-router-dom";
import { TiTick } from "react-icons/ti";

function CartProcess4() {
  const { t } = useTranslation();
  const [estimate, setEstimate] = useState({});
  
  const history = useNavigate();

  // لعرض وقت التقدير إذا كان نوع الطلب توصيل للمنزل
  useEffect(() => {
    if (localStorage.getItem("typeId") == 2) {
      const estimate = localStorage.getItem("timeEstimate");
      if (estimate) {
        setEstimate(JSON.parse(estimate));
      }
    }
  }, []);

  return (
    <div className="cartProcess">
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "20px",
        textAlign: "center"
      }}>
        
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          marginTop: "20px"
        }}>
          <h1 style={{
            fontFamily: "Cairo",
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "28px",
            lineHeight: "45px",
            letterSpacing: "-0.3px",
            color: "#331900",
            marginBottom: "10px"
          }}>
            {t("order-completed")}
          </h1>
          
          <div style={{
            width: "100px",
            height: "100px",
            backgroundColor: "#28a745",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            animation: "pulse 2s infinite"
          }}>
            <TiTick size={60} color="white" />
          </div>
          
          <p style={{
            fontSize: "18px",
            fontWeight: "500",
            color: "#666",
            maxWidth: "500px",
            margin: "10px 0",
            textAlign: "center"
          }}>
            {t("order-completed-message")}
          </p>
          
          {/* عرض وقت التقدير إذا كان توصيل للمنزل */}
          {estimate.deliveryTime && (
            <div style={{
              backgroundColor: "#f8f9fa",
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #e9ecef",
              maxWidth: "400px",
              width: "100%"
            }}>
              <p style={{ margin: 0, color: "#495057", fontWeight: "600" }}>
                ⏱️ {t("estimated-delivery")}:
              </p>
              <p style={{ margin: "5px 0 0 0", color: "#28a745", fontSize: "16px" }}>
                {estimate.deliveryTime}
              </p>
            </div>
          )}
          
          <div style={{
              marginTop: "10px",
              "display": "flex",
              "justifyContent": "center",
              "alignItems": "center",
              "gap": "20px"
          }}>
            <button
              onClick={() => history("/profile/myOrders")}
              style={{
                backgroundColor: "#ffc107",
                color: "#331900",
                border: "none",
                padding: "12px 30px",
                borderRadius: "8px",
                fontSize: "18px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#e0a800";
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#ffc107";
                e.target.style.transform = "scale(1)";
              }}
            >
              {t("track-order")}
            </button>
            
            <button
              onClick={() => history("/")}
              style={{
                backgroundColor: "transparent",
                color: "#6c757d",
                border: "1px solid #6c757d",
                padding: "12px 30px",
                borderRadius: "8px",
                fontSize: "16px",
                cursor: "pointer",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#6c757d";
                e.target.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "#6c757d";
              }}
            >
              {t("back-to-home")}
            </button>
          </div>
        </div>
      </div>
      
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `}
      </style>
    </div>
  );
}

export default CartProcess4;